import ScalarListbox_vue_vue_type_script_setup_true_lang_default from "./ScalarListbox.vue.script.js";
//#region src/components/ScalarListbox/ScalarListbox.vue
var ScalarListbox_default = ScalarListbox_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarListbox_default as default };

//# sourceMappingURL=ScalarListbox.vue.js.map